import { render, staticRenderFns } from "./optional.vue?vue&type=template&id=6e630174&scoped=true"
import script from "./optional.vue?vue&type=script&lang=ts"
export * from "./optional.vue?vue&type=script&lang=ts"
import style0 from "./optional.vue?vue&type=style&index=0&id=6e630174&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e630174",
  null
  
)

export default component.exports